/*
  Ported from src/components/ChaosSection.tsx — scroll-triggered text reveal +
  SVG mesh-thread line-draw. Depends on gsap.min.js/gsap-scrolltrigger.min.js
  (loaded globally in theme.liquid).
*/
(function () {
  function initChaos(root) {
    if (typeof window.gsap === 'undefined') return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    if (ScrollTrigger) gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      root.querySelectorAll('.oblivion-chaos__reveal'),
      { opacity: 0, y: 40 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.15,
        ease: 'power3.out',
        scrollTrigger: { trigger: root, start: 'top 70%' },
      }
    );

    root.querySelectorAll('.oblivion-chaos__thread').forEach(function (line, i) {
      var length = line.getTotalLength();
      gsap.set(line, { strokeDasharray: length, strokeDashoffset: length });
      gsap.to(line, {
        strokeDashoffset: 0,
        duration: 1.4,
        delay: i * 0.12,
        ease: 'power2.inOut',
        scrollTrigger: { trigger: root, start: 'top 60%' },
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-chaos]').forEach(initChaos);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
